<style lang="stylus">
    .echart-editor
        user-select none
        &.outsideScreen
            .ivu-modal
                position absolute
                left -10000px
        .ivu-modal-wrap
            display flex
            align-items center
            justify-content center
        .ivu-modal
            top unset
        .ivu-modal-close
            top 12px
            svg
                width 16px
                height 16px
                color:var(--svg-color-gray-42)
        .ivu-modal-header
            height 40px
            padding 10px 8px 10px 24px
            border-bottom none
            .ivu-modal-header-inner
                font-size 14px
                color var(--text-color-primary)
                font-weight 700
        .ivu-modal-body
            position relative
            padding 24px
            padding-top 16px
            height 488px
        .echart-editor-container
            width 100%
            .work-area
                display flex
                column-gap 16px
                height 392px
                margin-bottom 24px
                .preview-area
                    width 544px
                    border 1px solid var(--border-color-gray1)
                    border-radius 8px
                    background-color var(--bg-color-tertiary)
                .tool-area
                    display flex
                    flex-direction column
                    justify-content flex-end
                    width 32px
                    height 100%
                    .tool-icon
                        width 24px
                        height 24px
                        border-radius 4px
                        &:not(:last-child)
                            margin-bottom 8px
                        svg
                            width 24px
                            height 24px
                            color var(--svg-color-primary)
                        &.active
                            background var(--theme-color-16)
                            svg
                                color var(--themeColor)
                        &:hover
                            background var(--theme-color-10)
                            svg
                                color var(--themeColor)
                    .tool-option
                        width 32px
                        height 32px
                        padding 4px
                        border-radius 6px
                        box-shadow $box-shadow

                    .tool-btn
                        display flex
                        flex-direction column
                        width 32px
                        padding 8px 4px
                        border-radius 6px
                        margin-bottom 8px
                        box-shadow $box-shadow

                    .tool-label
                        display flex
                        flex-direction column
                        width 32px
                        padding 4px
                        border-radius 6px
                        margin-bottom 8px
                        box-shadow $box-shadow
                        .label-colorbox
                            display flex
                            flex-direction column
                            margin 0 4px
                            &.extra-margin
                                margin 4px 4px
                            .label-btn
                                width 16px
                                height 16px
                                border-radius 50%
                                cursor pointer
                                border 1px solid rgba(255, 255, 255, 0.15)
                                &:not(:last-child)
                                    margin-bottom 8px
                                &.ban
                                    background rgba(0, 0, 0, 0.15) !important

                        .label-arrow
                            padding 4px
                            width 24px
                            height 24px
                            border-radius 6px
                            cursor pointer
                            &.ban
                                color rgba(66, 66, 66, 0.4)
                                pointer-events none
                                svg
                                    color rgba(66, 66, 66, 0.4)
                            svg
                                width 16px
                                height 16px
                                main_svgColor()
                            &:hover
                                background rgba(0, 0, 0, 0.06)
                            &.uparrow
                                margin-bottom 2px
                            &.downarrow
                                margin-top 2px
                                transform rotate(180deg)
            .confirm-btn
                display flex
                justify-content center
                align-items center
                float right
                height 32px
                padding 8px 16px
                background var(--themeColor)
                color #fff
                font-size 12px
                border-radius 6px
                cursor pointer
</style>

<template>
    <div>
        <Modal
            v-model="showEditor"
            class="echart-editor"
            :class="{ outsideScreen: outsideScreen || type == 'outScreen' }"
            :title="$t('echartTitle')"
            :mask="false"
            :footer-hide="true"
            :width="640"
            @on-ok=""
            @on-cancel="closeEditor"
        >
            <template #close>
                <iconSymbol name="close" />
            </template>

            <div class="echart-editor-container">
                <div class="work-area">
                    <div class="preview-area" ref="main"></div>
                    <div class="tool-area">
                        <div class="tool-label" v-if="displayColorList.length > 0">
                            <div class="label-arrow uparrow" :class="{ ban: banUp }" v-show="showColorArrow" @click="clickArrowUp">
                                <iconSymbol name="tool-arrow" />
                            </div>
                            <div class="label-colorbox" :class="{ 'extra-margin': !showColorArrow }">
                                <div
                                    class="label-btn"
                                    :class="{ ban: item.gray }"
                                    v-for="(item, index) in displayColorList"
                                    :style="{ background: item.color }"
                                    :key="index"
                                    @click.stop="clickLegendColor($event, index)"
                                ></div>
                            </div>
                            <div class="label-arrow downarrow" :class="{ ban: banDown }" v-show="showColorArrow" @click="clickArrowDown">
                                <iconSymbol name="tool-arrow" />
                            </div>
                        </div>
                        <div class="tool-btn">
                            <div
                                class="tool-icon"
                                :class="{
                                    active: chartCurrentType == item || (item == 'stack' && isStack),
                                }"
                                v-for="item in toolList"
                                :key="item"
                                :title="$t(item)"
                                @click="clickTtoolBtn(item)"
                            >
                                <iconSymbol :name="`tool-${item}`" />
                            </div>
                        </div>
                        <div class="tool-option">
                            <Dropdown :data="settingList" @selectData="clickSettingList($event)">
                                <div class="tool-icon">
                                    <iconSymbol name="tool-setting" />
                                </div>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <div class="confirm-btn" @click="insertToPage">{{ $t("confirmText") }}</div>
            </div>
            <ColorSelector ref="colorSelector" @setColor="setColor" />

            <LabelModal v-if="showLabelModal" @closeEvent="closeLabel" @changeLabel="changeLabel" :label="chartOption.labelData.label" />

            <SeriesModal
                ref="seriesModal"
                v-if="showSeriesModal"
                @closeEvent="closeSeriesModal"
                @changeLegend="changeLegendPosition"
                @changeColor="changeColor"
                :colorList="colorList"
                :legend="chartOption.legendData.legend"
            />

            <DataModal
                v-if="showDataModal"
                @closeEvent="closeDataModal"
                @changeDataset="changeDataset"
                :dataset="chartOption.dataset"
                :colorList="dataModalColorList"
            />
        </Modal>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import * as echarts from "echarts";
    import Dropdown from "./MouseEnterDropdown.vue";
    import LabelModal from "./LabelModal.vue";
    import SeriesModal from "./SeriesModal.vue";
    import ColorSelector from "./ColorSelector.vue";
    import DataModal from "./DataModal.vue";
    import { formatEchartOptions } from "../ChartData";

    @Component({
        components: {
            LabelModal,
            Dropdown,
            SeriesModal,
            ColorSelector,
            DataModal,
        },
    })
    export default class ChartEditor extends Vue {
        @Prop()
        type;
        showEditor = false;
        finishSetOption = false;
        currentChart = null;
        shapeId = 0;
        chartName = "";
        insertDone = true;
        insertToPage(undo = true, position?) {
            const svgPreview = this.chart.renderToSVGString();
            const option = this.chart.getOption();

            const chartType = this.chartType;
            let params = JSON.stringify([svgPreview, JSON.stringify(option), chartType, this.shapeId]);
            window["_view"].insertEchart(params, undo, position);
            if (this.chartName) {
                this.sensors.track("echartInsertCanvas", {
                    Catalogues: "chart",
                    chart_type: this.chartName,
                });
            }
            this.closeEditor();
        }
        doEditor(chart, type, shapeId = 0, chartName, autoInsert = false, position?) {
            if (!this.insertDone) return;
            this.insertDone = false;
            this.resetOption();
            this.shapeId = shapeId;
            this.chartName = chartName;
            this.currentChart = JSON.parse(chart.option);
            if (autoInsert) {
                this.outsideScreen = true;
            }
            this.showEditor = true;
            this.chartType = type;
            if (this.currentChart?.edEchartLabel == "bar13") {
                // 折柱混合图
                this.chartType = "linebar";
            }
            let ts = this;
            this.$nextTick(() => {
                this.initChart();
                if (autoInsert) {
                    const onFinish = () => {
                        if (!ts.finishSetOption) {
                            return;
                        }
                        this.chart.off("finished", onFinish);
                        this.insertToPage(true, position);
                        setTimeout(() => {
                            this.outsideScreen = false;
                            this.$bus.$emit("aiCreateEchartDone");
                            this.insertDone = true;
                        }, 300); // iview modal exit full in 300ms
                    };
                    this.chart.on("finished", onFinish);
                }
                this.drawEchart();
            });
        }
        get defaultAxisColor() {
            return this.isDiagramDark ? "#fff" : "#222";
        }
        setAxisColor(option) {
            ["xAxis", "radiusAxis"].forEach((axisName) => {
                if (option[axisName]) {
                    option[axisName].forEach((item) => {
                        let color = item?.axisLine?.lineStyle?.color || this.defaultAxisColor;
                        Object.assign(item, {
                            axisLabel: {
                                color,
                            },
                            axisLine: {
                                lineStyle: {
                                    color,
                                },
                            },
                        });
                        item.axisLabel.color = color;
                    });
                }
            });
            if (option.yAxis) {
                option.yAxis.forEach((item) => {
                    let color = item.axisLine.lineStyle.color || this.defaultAxisColor;
                    item.axisLabel.color = color;
                });
            }
        }
        outsideScreen = false;
        aiCreateEchart(chart, type, undo) {
            this.resetOption();
            this.currentChart = this.setAiEchartSeriesColor(JSON.parse(chart.option), type);
            this.showEditor = true;
            this.outsideScreen = true;
            this.chartType = type;
            let ts = this;
            this.$nextTick(() => {
                this.initChart();
                const onFinish = () => {
                    if (!ts.finishSetOption) {
                        return;
                    }
                    this.chart.off("finished", onFinish);
                    this.insertToPage(undo);
                    setTimeout(() => {
                        this.outsideScreen = false;
                        this.$bus.$emit("aiCreateEchartDone");
                    }, 300); // iview modal exit full in 300ms
                };
                this.chart.on("finished", onFinish);
                this.drawEchart();
            });
        }
        // fix: p122_8937
        setAiEchartSeriesColor(option: any, type) {
            const defaultColorList = ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"];

            if (["radar", "sankey"].includes(type)) {
                const setColor = (item, index) => {
                    const color = defaultColorList[index % defaultColorList.length];
                    if (item?.itemStyle?.color) {
                    } else {
                        Object.assign(item, {
                            itemStyle: {
                                color: color,
                            },
                        });
                    }
                };
                if (Array.isArray(option?.series)) {
                    option.series.forEach((serie) => {
                        (serie?.data || []).forEach(setColor);
                    });
                } else {
                    (option?.series?.data || []).forEach(setColor);
                }
            } else if (["parallel"].includes(type)) {
                const setColor = (item, index) => {
                    const color = defaultColorList[index % defaultColorList.length];
                    if (item?.lineStyle?.color) {
                    } else {
                        Object.assign(item, {
                            lineStyle: {
                                color: color,
                            },
                        });
                    }
                };
                if (Array.isArray(option?.series)) {
                    option.series.forEach(setColor);
                } else {
                    setColor(option?.series || {}, 0);
                }
            }

            return option;
        }
        showOutsideModal(option, type) {
            this.currentChart = JSON.parse(option);
            this.outsideScreen = true;
            this.showEditor = true;
            this.chartType = type;

            return new Promise((rs, rj) => {
                this.$nextTick(() => {
                    this.initChart();
                    const onFinish = () => {
                        this.chart.off("finished", onFinish);
                        const closeFunc = () => {
                            this.closeEditor();
                            setTimeout(() => {
                                this.outsideScreen = false;
                            }, 300); // iview modal exit full in 300ms
                        };
                        rs(closeFunc);
                    };
                    this.chart.on("finished", onFinish);
                    this.drawEchart();
                });
            });
        }
        get activeChartId() {
            return this.$store.state.newEchart.activeChartId;
        }
        prevId = 0;
        renderOption(option, type) {
            if (this.prevId == this.activeChartId) return Promise.resolve();
            return new Promise((rs) => {
                this.prevId = this.activeChartId;
                this.resetOption();
                this.currentChart = JSON.parse(option);
                this.chartType = type;
                this.initChart();
                const onFinish = () => {
                    rs(null);
                    this.chart.off("finished", onFinish);
                };
                this.chart.on("finished", onFinish);
                this.drawEchart();
            });
        }
        resetOption() {
            this.isDataset = false;
            this.isEditingXAxis = false;
            this.isEditingYAxis = false;
            this.isStack = false;
            this.chartCurrentType = "";
            this.shapeId = 0;
            this.chartName = "";
            this.closeLabel();
            this.closeSeriesModal();
            this.closeDataModal();
        }
        closeEditor() {
            if (this.type == "outScreen") return;
            this.showEditor = false;
            this.finishSetOption = false;
            this.resetOption();
        }
        chartType = "";
        chart = null;
        get banlegend() {
            return ["sunburst", "gauge", "graph", "sankey", "radar", "heatmap", "scatter"].includes(this.chartType);
        }

        get isDiagramDark() {
            return window["_view"]._isDarkTheme();
        }
        initChart() {
            let main = this.$refs.main as HTMLElement;
            this.chart && echarts.dispose(this.chart);
            this.chart = echarts.init(main, undefined, { renderer: "svg" });
            // window["test"] = this.chart
        }
        drawEchart() {
            this.chart.setOption(this.currentChart);
            this.initPreSet();
            this.initDataSet();
            this.initToolStatus();
            this.loadOption();

            const nowOption = this.chart.getOption();
            if (this.isDiagramDark) {
                formatEchartOptions(nowOption, this.isDiagramDark, this.chartType);
            }
            this.setAxisColor(nowOption);
            this.finishSetOption = true;
            this.chart.setOption(nowOption);
        }
        deepClone(obj: object) {
            return JSON.parse(JSON.stringify(obj));
        }
        initPreSet() {
            // 设置默认legend和默认label
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            const initLegend = () => {
                let nameIndex = 1;
                const legend: any = {
                    show: true,
                    data: [],
                    selected: {},
                    top: "top",
                    left: "center",
                    bottom: "auto",
                    right: "auto",
                    orient: "horizontal",
                    itemWidth: 25,
                    itemHEight: 14,
                    itemGap: 10,
                    textStyle: {
                        color: this.isDiagramDark ? "#fff" : "#333",
                    },
                };
                if (this.banlegend) {
                    return;
                }
                if (this.chartType == "pie") {
                    let data = seriesList[0].data;
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        legend.data.push(item.name || "unKnow");
                    }
                    if (nowOption.edEchartLabel === "pie06") {
                        for (let i = 0; i < seriesList[1].data.length; i++) {
                            const item = seriesList[1].data[i];
                            legend.data.push(item.name || "unKnow");
                        }
                    }
                } else if (this.chartType == "funnel") {
                    for (let item of seriesList[0].data) {
                        legend.data.push(item.name || "unKnow");
                    }
                } else if (this.chartType == "waterfall") {
                    legend.data.push(seriesList[1]?.name ?? "unKnow");
                    legend.data.push(seriesList[2]?.name ?? "unKnow");
                } else {
                    for (let item of seriesList) {
                        if (item.name) {
                            legend.data.push(item.name);
                        } else {
                            const name = `series${nameIndex++}`;
                            legend.data.push(name);
                            item.name = name;
                        }
                    }
                }

                if (this.chartType == "candlestick" || this.chartType === "boxplot") {
                    legend.show = false;
                }
                return legend;
            };
            const initLabel = () => {
                const ignoreList = ["scatter"];
                if (ignoreList.includes(this.chartType) || nowOption.edEchartLabel === "pie06") return;
                const label = {
                    show: true,
                    distance: 5,
                    rotate: 0,
                    position: "top",
                };
                return Object.assign(label, seriesList[0]?.label || {});
            };
            const initColor = () => {
                // 桑基图，修改颜色配置
                if (this.chartType == "sankey") {
                    seriesList[0].lineStyle.opacity = 1;
                    seriesList[0].links.forEach((link) => {
                        link.lineStyle = { opacity: 0.2 };
                    });
                    return;
                }

                const ignoreList = ["candlestick", "heatmap", "graph", "sunburst"];
                if (ignoreList.includes(this.chartType)) return;
                const defaultColor = nowOption.color;
                const setDataColor = (data, defaultColor) => {
                    let colorIndex = 0;
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].itemStyle) {
                            data[i].itemStyle.color = data[i].itemStyle.color || defaultColor[colorIndex++];
                        } else {
                            Object.assign(data[i], {
                                itemStyle: {
                                    color: defaultColor[colorIndex++],
                                },
                            });
                        }
                    }
                };
                if (this.chartType == "pie") {
                    setDataColor(seriesList[0].data, defaultColor);
                    if (nowOption.edEchartLabel === "pie06") {
                        setDataColor(seriesList[1].data, defaultColor);
                    }
                } else if (this.chartType == "funnel") {
                    for (let j = 0; j < seriesList.length; j++) {
                        setDataColor(seriesList[j].data, defaultColor);
                    }
                } else {
                    setDataColor(seriesList, defaultColor);
                }
            };
            const remove = () => {
                let keys = Object.keys(nowOption);
                let temp = this.deepClone(nowOption);
                if (keys.includes("toolbox")) {
                    Object.assign(temp, {
                        toolbox: [],
                    });
                }
                if (keys.includes("title") && this.chartType !== "boxplot") {
                    Object.assign(temp, {
                        title: [],
                    });
                }
                this.chart.setOption(temp, true);
            };
            remove();
            initColor();
            const preSet = {
                series: seriesList,
                legend: initLegend(),
                label: initLabel(),
            };
            this.chart.setOption(Object.assign({}, preSet));
        }
        isDataset = false;
        chartOption = {
            seriesColorList: [], // 图例颜色列表
            legendData: {
                // legend数据
                legend: {
                    show: true,
                    data: [],
                    selected: {},
                    top: "top",
                    left: "center",
                    bottom: "auto",
                    right: "auto",
                    orient: "horizontal",
                    itemWidth: 25,
                    itemHEight: 14,
                    itemGap: 10,
                },
            },
            labelData: {
                label: {
                    show: true,
                    distance: 5,
                    rotate: 0,
                    position: "top",
                },
            },
            dataset: [],
        };
        initDataSet() {
            let result: any = [];
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            if (nowOption.dataset) {
                this.isDataset = true;
                if (this.chartType == "bar") {
                    result = this.deepClone(nowOption.dataset[0].source);
                } else if (this.chartType == "boxplot") {
                    result = this.deepClone(nowOption.dataset[0].source);
                    for (let i = 1; i < nowOption.dataset.length; i++) {
                        let source = nowOption.dataset[i].source;
                        if (source) {
                            for (let j = 0; j < source.length; j++) {
                                if (result[j]) {
                                    result[j] = result[j].concat(source[j]);
                                }
                            }
                        }
                    }
                }
            } else {
                this.isDataset = false;
                if (this.chartType == "pie") {
                    let data = seriesList[0].data;
                    for (let i = 0; i < data.length; i++) {
                        if (!result[i]) {
                            result.push([]);
                        }
                        result[i][0] = data[i].name;
                        result[i][1] = data[i].value;
                    }
                } else if (this.chartType == "scatter") {
                    for (let i = 0; i < seriesList.length; i++) {
                        let series = seriesList[i];
                        let name = [series.name, "--"];
                        if (!result[0]) {
                            result.push(name);
                        } else {
                            result[0] = result[0].concat(name);
                        }
                        for (let j = 0; j < series.data.length; j++) {
                            let numData = [series.data[j][0], series.data[j][1]];
                            if (!result[j + 1]) {
                                result.push(numData);
                            } else {
                                result[j + 1] = result[j + 1].concat(numData);
                            }
                        }
                    }
                } else if (this.chartType == "candlestick") {
                    for (let i = 0; i < seriesList.length; i++) {
                        let series = seriesList[i];
                        let name = [series.name, "--", "--", "--"];
                        if (!result[0]) {
                            result.push(name);
                        } else {
                            result[0] = result[0].concat(name);
                        }
                        for (let j = 0; j < series.data.length; j++) {
                            let numData = [series.data[j][0], series.data[j][1], series.data[j][2], series.data[j][3]];
                            if (!result[j + 1]) {
                                result.push(numData);
                            } else {
                                result[j + 1] = result[j + 1].concat(numData);
                            }
                        }
                    }
                } else if (this.chartType == "radar") {
                    let radar = nowOption.radar;
                    for (let i = 0; i < radar.length; i++) {
                        let dataArr = radar[i].indicator;
                        let dataLength = seriesList[i].data.length;
                        let seriesValueName = [];
                        for (let k = 0; k < dataLength; k++) {
                            seriesValueName.push(seriesList[i].data[k].name);
                        }
                        let name = [seriesList[i].name, "max", "min"].concat(seriesValueName);
                        let dataIndex = 0;
                        if (!result[0]) {
                            result.push(name);
                        } else {
                            dataIndex = result[0].length;
                            result[0] = result[0].concat(name);
                        }
                        for (let j = 0; j < dataArr.length; j++) {
                            let values = seriesList[i].data.map((item: any) => item.value[j]);
                            let numData = [dataArr[j].name || dataArr[j].text, dataArr[j].max, dataArr[j].min].concat(values);
                            if (!result[j + 1]) {
                                result.push(new Array(dataIndex).fill(""));
                                result[j + 1] = result[j + 1].concat(numData);
                            } else {
                                result[j + 1] = result[j + 1].concat(numData);
                            }
                        }
                    }
                } else if (this.chartType == "heatmap") {
                    result = this.deepClone(seriesList[0].data);
                    for (let i = 1; i < seriesList.length; i++) {
                        let source = seriesList[i].data;
                        for (let j = 0; j < source.length; j++) {
                            if (result[j]) {
                                result[j] = result[j].concat(source[j]);
                            } else {
                                let temp = new Array(result[j - 1].length).fill("");
                                result.push(temp.concat(source[j]));
                            }
                        }
                    }
                } else if (this.chartType == "graph") {
                    if (Object.prototype.toString.call(seriesList[0].data[0]) == "[object Array]") {
                        result = this.deepClone(seriesList[0].data);
                    } else {
                        result = [this.deepClone(seriesList[0].data)];
                    }
                } else if (this.chartType == "sunburst") {
                    const flat = (data: any, parentName = "null") => {
                        return data.reduce((acc: any, curr: any) => {
                            acc.push({ ...curr, parentName, value: curr.value });
                            if (curr.children) {
                                acc = acc.concat(flat(curr.children, curr.name));
                            }
                            return acc;
                        }, []);
                    };
                    let flatTree = flat(seriesList[0].data);
                    result.push(["name", "value", "parent"]);
                    for (let i = 0; i < flatTree.length; i++) {
                        let item = flatTree[i];
                        result.push([item.name, item.value, item.parentName]);
                    }
                } else if (this.chartType == "parallel") {
                    for (let item of seriesList) {
                        for (let data of item.data) {
                            result.push(data);
                        }
                    }
                } else if (this.chartType == "sankey") {
                    let links = seriesList[0].links;
                    for (let item of links) {
                        let temp = [];
                        temp.push(item.source);
                        temp.push(item.target);
                        temp.push(item.value);
                        result.push(temp);
                    }
                } else if (this.chartType == "funnel") {
                    for (let i = 0; i < seriesList.length; i++) {
                        let data = seriesList[i].data;
                        for (let j = 0; j < data.length; j++) {
                            let temp = [];
                            temp.push(data[j].name);
                            temp.push(data[j].value);
                            result.push(temp);
                        }
                    }
                } else if (this.chartType == "gauge") {
                    for (let i = 0; i < seriesList.length; i++) {
                        let data = seriesList[i].data;
                        if (data) {
                            for (let j = 0; j < data.length; j++) {
                                let temp = [];
                                temp.push(data[j].name);
                                temp.push(data[j].value);
                                result.push(temp);
                            }
                        }
                    }
                } else {
                    const nameList = [];
                    for (let i = 0; i < seriesList.length; i++) {
                        let name = seriesList[i].name;
                        let data = seriesList[i].data;
                        nameList.push(name);
                        if (data.length > 0) {
                            for (let j = 0; j < data.length; j++) {
                                if (!result[j]) {
                                    result.push([]);
                                }
                                result[j][i] = data[j];
                            }
                        }
                    }
                    result.unshift(nameList);
                }
            }
            this.initYAxisData(result, nowOption.dataset);
            this.initXAxisData(result, nowOption.dataset);
            this.chartOption.dataset = result;
        }
        initXAxisData(arr: string[][], isDataset = false) {
            if (!isDataset && ["line", "bar", "candlestick"].includes(this.chartType)) {
                let data = this.getXAxis();
                if (!data) return arr;
                if (data.length >= arr.length) {
                    arr = arr.concat(Array(data.length - arr.length).fill([]));
                } else {
                    data = data.concat(Array(arr.length - data.length).fill(""));
                }
                for (let i = 0; i < data.length; i++) {
                    arr[i].unshift(data[i]);
                }
            } else {
                return arr;
            }
        }
        initYAxisData(arr: string[][], isDataset = false) {
            if (!isDataset && ["line", "bar", "candlestick"].includes(this.chartType)) {
                let data = this.getYAxis();
                if (!data) return arr;
                if (data.length >= arr.length) {
                    arr = arr.concat(Array(data.length - arr.length).fill([]));
                } else {
                    data = data.concat(Array(arr.length - data.length).fill(""));
                }
                for (let i = 0; i < data.length; i++) {
                    arr[i].unshift(data[i]);
                }
            } else {
                return arr;
            }
        }
        isStack = false;
        chartCurrentType = "";
        initToolStatus() {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            this.isStack = seriesList[0].stack != undefined;
            this.chartCurrentType = seriesList[0].type;
        }

        loadOption() {
            let nowOption = this.chart.getOption();
            const defaultColor = nowOption.color;
            const seriesList = this.deepClone(nowOption.series);
            let colorIndex = 0;

            // 初始化数据
            this.chartOption.legendData.legend = nowOption.legend[0] ? this.deepClone(nowOption.legend[0]) : [];
            this.chartOption.seriesColorList = [];
            // 设置label初始值
            this.chartOption.labelData.label = this.deepClone(seriesList[0]?.label || {});

            if (this.chartType == "pie") {
                let data = seriesList[0].data;
                for (let i = 0; i < data.length; i++) {
                    let item = data[i];
                    if (item.itemStyle && item.itemStyle.color) {
                        this.chartOption.seriesColorList.push(item.itemStyle.color);
                    } else {
                        this.chartOption.seriesColorList.push(defaultColor[colorIndex]);
                    }
                    colorIndex = colorIndex + 1 > defaultColor.length - 1 ? 0 : colorIndex + 1;
                    this.chartOption.legendData.legend.data[i] = item.name;
                }
            } else if (this.chartType == "funnel") {
                for (let j = 0; j < seriesList.length; j++) {
                    let data = seriesList[j].data;
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (item.itemStyle.color) {
                            this.chartOption.seriesColorList.push(item.itemStyle.color);
                        } else {
                            this.chartOption.seriesColorList.push(defaultColor[colorIndex]);
                        }
                        colorIndex = colorIndex + 1 > defaultColor.length - 1 ? 0 : colorIndex + 1;
                        this.chartOption.legendData.legend.data[i] = item.name;
                    }
                }
            } else if (this.chartType === "parallel") {
                for (let i = 0; i < seriesList.length; i++) {
                    let item = seriesList[i];
                    if (item.lineStyle && item.lineStyle.color) {
                        this.chartOption.seriesColorList.push(item.lineStyle.color);
                    } else {
                        this.chartOption.seriesColorList.push(defaultColor[colorIndex]);
                        colorIndex = colorIndex + 1 > defaultColor.length - 1 ? 0 : colorIndex + 1;
                    }
                    if (item.name && this.chartOption.legendData.legend.data) {
                        this.chartOption.legendData.legend.data[i] = item.name;
                    }
                }
            } else {
                for (let i = 0; i < seriesList.length; i++) {
                    let item = seriesList[i];
                    if (item.itemStyle && item.itemStyle.color) {
                        this.chartOption.seriesColorList.push(item.itemStyle.color);
                    } else {
                        this.chartOption.seriesColorList.push(defaultColor[colorIndex]);
                        colorIndex = colorIndex + 1 > defaultColor.length - 1 ? 0 : colorIndex + 1;
                    }
                    if (item.name && this.chartOption.legendData.legend.data) {
                        this.chartOption.legendData.legend.data[i] = item.name;
                    }
                }
            }
            this.$store.commit("setEchartSeriesColors", [...this.chartOption.seriesColorList]);
        }
        expandOption(obj: any) {
            this.chart.setOption(Object.assign({}, obj));
            this.loadOption();
        }

        isEditingXAxis = false;
        isEditingYAxis = false;
        getXAxis() {
            const nowOption = this.chart.getOption();
            if (!nowOption.xAxis || !nowOption.xAxis[0] || !nowOption.xAxis[0].data) return;
            const data = this.deepClone(nowOption.xAxis[0].data);
            data.unshift("category");
            this.isEditingXAxis = true;
            return data;
        }

        setXAxis(data: Array<string>) {
            data.shift();
            data = data.filter((item) => item != "");
            const nowOption = this.chart.getOption();
            const temp = this.deepClone(nowOption.xAxis);
            temp[0].data = data;
            this.isEditingXAxis = false;
            return { xAxis: temp };
        }

        getYAxis() {
            const nowOption = this.chart.getOption();
            if (!nowOption.yAxis || !nowOption.yAxis[0] || !nowOption.yAxis[0].data) return;
            const data = this.deepClone(nowOption.yAxis[0].data);
            data.unshift("category");
            this.isEditingYAxis = true;
            return data;
        }

        setYAxis(data: Array<string>) {
            data.shift();
            data = data.filter((item) => item != "");
            const nowOption = this.chart.getOption();
            const temp = this.deepClone(nowOption.yAxis);
            temp[0].data = data;
            this.isEditingYAxis = false;
            return { yAxis: temp };
        }

        colorIndex = 0;
        get colorList() {
            const arr = [];
            const grayList = [];
            let nameList = this.chartOption.legendData.legend.data || [];
            let selected = this.chartOption.legendData.legend.selected;
            for (let item in selected) {
                if (!selected[item]) {
                    grayList.push(item);
                }
            }
            for (let i = 0; i < nameList.length; i++) {
                if (nameList[i]) {
                    arr.push({
                        name: nameList[i],
                        color: this.chartOption.seriesColorList[i],
                        gray: grayList.includes(nameList[i]),
                    });
                }
            }
            return arr;
        }
        get showColorArrow() {
            return this.colorList.length > 8;
        }
        get banDown() {
            return this.colorIndex == this.colorList.length - 8;
        }
        get banUp() {
            return this.colorIndex == 0;
        }
        get displayColorList() {
            let list = this.colorList;
            return list.slice(this.colorIndex, this.colorIndex + 8);
        }
        clickArrowUp() {
            if (this.banUp) return;
            this.colorIndex = this.colorIndex - 1;
        }
        clickArrowDown() {
            if (this.banDown) return;
            this.colorIndex = this.colorIndex + 1;
        }
        get dataModalColorList() {
            let list = this.colorList;
            if (this.isEditingXAxis) {
                list = [{ name: "", color: "", gray: false }].concat(list);
            } else if (this.isEditingYAxis) {
                list = [{ name: "", color: "", gray: false }].concat(list);
            }
            return list;
        }
        legendColorIndex = 0;
        clickLegendColor(e: MouseEvent, index: number) {
            this.legendColorIndex = index;
            let x = e.pageX - e.offsetX,
                y = e.pageY - e.offsetY,
                w = (e.target as HTMLElement).clientWidth,
                h = (e.target as HTMLElement).clientHeight;
            (this.$refs.colorSelector as any).showSelector(this.displayColorList[index].color, {
                left: x,
                top: y + h,
            });
        }
        setColor(str: string) {
            this.changeColor({
                index: this.legendColorIndex,
                color: str,
            });
        }
        changeColor(obj: { index: number; color: string }) {
            let nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            if (this.chartType == "pie") {
                let data = seriesList[0].data;
                if (data[obj.index].itemStyle) data[obj.index].itemStyle.color = obj.color;
            } else if (this.chartType == "funnel") {
                let tempIndex = 0;
                for (let j = 0; j < seriesList.length; j++) {
                    let data = seriesList[j].data;
                    if (obj.index > data.length) {
                        tempIndex += data.length;
                    } else {
                        if (data[obj.index - tempIndex].itemStyle) data[obj.index - tempIndex].itemStyle.color = obj.color;
                    }
                }
            } else if (this.chartType === "parallel") {
                if (seriesList[obj.index].lineStyle) seriesList[obj.index].lineStyle.color = obj.color;
            } else {
                if (seriesList[obj.index].itemStyle) seriesList[obj.index].itemStyle.color = obj.color;
            }

            this.expandOption({
                series: seriesList,
            });
        }

        get toolList() {
            const onlyEdit = [
                "pie",
                "scatter",
                "candlestick",
                "radar",
                "boxplot",
                "heatmap",
                "graph",
                "parallel",
                "sankey",
                "funnel",
                "gauge",
                "sunburst",
            ];
            if (onlyEdit.includes(this.chartType)) {
                return ["edit"];
            }
            return ["edit", "line", "bar", "stack", "restore"];
        }
        get settingList() {
            return [
                {
                    label: this.$t("label"),
                    value: "label",
                },
                {
                    label: this.$t("series"),
                    value: "series",
                },
            ];
        }
        showLabelModal = false;
        showSeriesModal = false;
        showDataModal = false;
        clickSettingList(index: number) {
            if (index == 0) {
                this.closeSeriesModal();
                this.closeDataModal();
                this.showLabelModal = true;
            } else if (index == 1) {
                if (this.banlegend) {
                    return;
                }
                this.closeDataModal();
                this.closeLabel();
                this.showSeriesModal = true;
            } else if (index == 2) {
                this.closeSeriesModal();
                this.closeLabel();
                this.showDataModal = true;
            }
        }
        closeLabel() {
            this.showLabelModal = false;
        }
        closeSeriesModal() {
            this.showSeriesModal = false;
        }
        closeDataModal() {
            this.showDataModal = false;
        }
        clickTtoolBtn(key: string) {
            const map = new Map([
                [
                    "edit",
                    () => {
                        this.clickSettingList(2);
                        this.sensors.track("echartEditData", {
                            Catalogues: "chart",
                        });
                    },
                ],
                [
                    "line",
                    () => {
                        this.changeChartType("line");
                    },
                ],
                [
                    "bar",
                    () => {
                        this.changeChartType("bar");
                    },
                ],
                [
                    "stack",
                    () => {
                        this.changeChartType("stack");
                    },
                ],
                [
                    "restore",
                    () => {
                        this.restoreChart();
                    },
                ],
            ]);
            map.has(key) && map.get(key)!();
        }
        changeLabel(data: any) {
            let nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            let temp = data;
            if (temp.position == "hidden") {
                temp.show = false;
            } else {
                temp.show = true;
            }
            for (let item of seriesList) {
                item.label = Object.assign({}, temp);
            }
            this.expandOption({
                series: seriesList,
            });
        }
        changeLegendPosition(position: "topCenter" | "bottomCenter" | "topRight" | "middleRight" | "middleCenter" | "hidden") {
            const legendPositionCfg = {
                topCenter: {
                    top: "top",
                    left: "center",
                    right: undefined,
                    bottom: undefined,
                    orient: "horizontal",
                    itemWidth: 25,
                    itemHeight: 14,
                    itemGap: 10,
                },
                bottomCenter: {
                    top: "bottom",
                    left: "center",
                    right: undefined,
                    bottom: undefined,
                    orient: "horizontal",
                    itemWidth: 25,
                    itemHeight: 14,
                    itemGap: 10,
                },
                topRight: {
                    top: "top",
                    left: undefined,
                    right: 0,
                    bottom: undefined,
                    orient: "vertical",
                    itemWidth: 25,
                    itemHeight: 14,
                    itemGap: 10,
                },
                middleRight: {
                    top: "middle",
                    left: undefined,
                    right: 0,
                    bottom: undefined,
                    orient: "vertical",
                    itemWidth: 25,
                    itemHeight: 14,
                    itemGap: 10,
                },
                middleCenter: {
                    top: "middle",
                    left: "center",
                    right: undefined,
                    bottom: undefined,
                    orient: "vertical",
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 2,
                },
            };
            let nowOption = this.chart.getOption();
            const tempLegend = this.deepClone(nowOption.legend);
            if (position == "hidden") {
                tempLegend[0].show = false;
            } else {
                tempLegend[0].show = true;
                Object.assign(tempLegend[0], legendPositionCfg[position]);
            }
            this.expandOption({
                legend: tempLegend,
            });
        }
        restoreChart() {
            this.chart.dispatchAction({
                type: "restore",
                from: this.chart.id,
            });
            this.initPreSet();
            this.initToolStatus();
            this.loadOption();
        }

        changeChartType(type: string) {
            let nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            if (type == "line" || type == "bar") {
                for (let item of seriesList) {
                    item.type = type;
                }
                this.chartCurrentType = type;
                this.chartType = type;
            }
            if (type == "stack") {
                for (let item of seriesList) {
                    if (item.stack == undefined) {
                        item.stack = "all";
                    } else {
                        item.stack = undefined;
                    }
                }
                this.isStack = seriesList[0].stack != undefined;
            }
            this.expandOption({
                series: seriesList,
            });
        }

        datasetLegend(legend: any, type: string, index: number, nv: string, ov?: string) {
            const changeLegend = (nv: string, ov: string) => {
                if (nv == ov) return;
                if (index != -1) {
                    legend[0].data.splice(index, 1, nv);
                }
                let keys = Object.keys(legend[0].selected);
                if (keys.includes(ov)) {
                    let obj = {
                        [nv]: legend[0].selected[ov],
                    };
                    delete legend[0].selected[ov];
                    Object.assign(legend[0].selected, obj);
                }
            };
            const addLegend = (nv: string) => {
                legend[0].data.push(nv);
            };
            const deleteLegend = (v: string) => {
                let index = legend[0].data.indexOf(v);
                legend[0].data.splice(index, 1);
                let keys = Object.keys(legend[0].selected);
                if (keys.includes(v)) {
                    delete legend[0].selected[v];
                }
            };
            switch (type) {
                case "change": {
                    changeLegend(nv, ov as string);
                    break;
                }
                case "add": {
                    addLegend(nv);
                    break;
                }
                case "delete": {
                    // 此处nv是旧名称
                    deleteLegend(nv);
                }
            }
        }
        getDefaultData(type: string) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            let tempObj: any = {};
            if (seriesList[0]) {
                tempObj = seriesList[0];
                delete tempObj.name;
                delete tempObj.type;
                delete tempObj.data;
            }
            switch (type) {
                case "line_series": {
                    return Object.assign(
                        {
                            type: "line",
                            data: [],
                        },
                        tempObj
                    );
                }
                case "bar_series": {
                    return Object.assign(
                        {
                            data: [],
                            type: "bar",
                        },
                        tempObj
                    );
                }
                case "radar": {
                    return {
                        indicator: [],
                        radius: 80,
                    };
                }
                case "radar_series": {
                    return {
                        name: "",
                        type: "radar",
                        data: [],
                    };
                }
            }
        }
        setSeriesColor(data: any, color: string) {
            if (data.itemStyle) {
                data.itemStyle.color = color;
            } else {
                Object.assign(data, {
                    itemStyle: {
                        color: color,
                    },
                });
            }
            return data;
        }

        changeDataset(arr: Array<Array<string>>) {
            let xChange = null,
                yChange = null;
            if (this.isEditingXAxis) {
                let xAxisData = arr.reduce((p, c) => {
                    return p.push(c.shift()!), p;
                }, []);
                xChange = this.setXAxis(xAxisData);
            }
            if (this.isEditingYAxis) {
                let yAxisData = arr.reduce((p, c) => {
                    return p.push(c.shift()!), p;
                }, []);
                yChange = this.setYAxis(yAxisData);
            }
            if (this.chartType == "pie") {
                this.changeDatasetForPie(arr);
                return;
            }
            if (this.chartType == "scatter") {
                this.changeDatasetForScatter(arr);
                return;
            }
            if (this.chartType == "candlestick") {
                this.changeDatasetForCandlestick(arr);
                return;
            }
            if (this.chartType == "radar") {
                this.changeDatasetForRadar(arr);
                return;
            }
            if (this.chartType == "boxplot") {
                this.changeDatasetForBoxplot(arr);
                return;
            }
            if (this.chartType == "heatmap") {
                this.changeDatasetForHeatmap(arr);
                return;
            }
            if (this.chartType == "graph") {
                this.changeDatasetForGraph(arr);
                return;
            }
            if (this.chartType == "sunburst") {
                this.changeDatasetForSunburst(arr);
                return;
            }
            if (this.chartType == "parallel") {
                this.changeDatasetForParallel(arr);
                return;
            }
            if (this.chartType == "sankey") {
                this.changeDatasetForSankey(arr);
                return;
            }
            if (this.chartType == "funnel") {
                this.changeDatasetForFunnel(arr);
                return;
            }
            if (this.chartType == "gauge") {
                this.changeDatasetForGauge(arr);
                return;
            }
            if (this.isDataset) {
                const nowOption = this.chart.getOption();
                const dataset = this.deepClone(nowOption.dataset);
                dataset[0].source = arr;
                this.chart.setOption(
                    Object.assign(this.deepClone(nowOption), {
                        dataset: dataset,
                    }),
                    true
                );
                this.initDataSet();
                this.loadOption();
                return;
            }
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            const legend = this.deepClone(nowOption.legend);
            const changeDataSet = (arr: Array<Array<number | string>>) => {
                let result = [];
                for (let j = 0; j < arr[0].length; j++) {
                    let temp = [];
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[0][j] == "") {
                            break;
                        }
                        arr[i][j] != undefined && temp.push(arr[i][j]);
                    }
                    temp.length > 0 && result.push(temp);
                }
                return result;
            };
            let temp = changeDataSet(arr);
            let count = temp.length - seriesList.length;
            if (count == 0) {
                for (let i = 0; i < seriesList.length; i++) {
                    let name = temp[i].shift() as string;
                    let oldName = seriesList[i].name;
                    this.datasetLegend(legend, "change", i, name, oldName);
                    seriesList[i].name = name;
                    seriesList[i].data = temp[i];
                }
            } else if (count > 0) {
                // 新增series
                const defaultColorList = nowOption.color;
                seriesList.length = 0;
                legend[0].data = [];
                for (let i = seriesList.length; i < temp.length; i++) {
                    let tempSeries: any = this.getDefaultData(`${this.chartType}_series`);
                    let name = temp[i].shift() as string;
                    tempSeries.name = name;
                    tempSeries.data = temp[i];
                    tempSeries = this.setSeriesColor(tempSeries, defaultColorList[i % defaultColorList.length]);
                    seriesList.push(tempSeries);
                    this.datasetLegend(legend, "add", i, name);
                }
            } else {
                // 删除series
                let nowNameList = arr[0];
                for (let i = arr[0].length; i >= 0; i--) {
                    if (seriesList[i] && arr[0][i] == "") {
                        this.datasetLegend(legend, "delete", i, seriesList[i].name);
                        seriesList.splice(i, 1);
                    }
                }
            }
            this.chart.setOption(
                Object.assign(
                    this.deepClone(nowOption),
                    {
                        series: seriesList,
                        legend: legend,
                    },
                    xChange,
                    yChange
                ),
                true
            );
            this.initDataSet();
            this.loadOption();
        }
        changeDatasetForPie(arr: Array<Array<string>>) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            const legend = this.deepClone(nowOption.legend);
            const oldData = seriesList[0].data;

            let tempData: Array<{ name: string; value: string }> = [];
            let count = arr.length - oldData.length;
            if (count == 0) {
                let deleteFlag = false;
                for (let i = 0; i < arr.length; i++) {
                    let name = arr[i][0] as string;
                    let oName = oldData[i].name;
                    let value = arr[i][1] as string;
                    if (arr[i].length != 1) {
                        this.datasetLegend(legend, "change", i, name, oName);
                        tempData.push({
                            value: value,
                            name: name,
                        });
                    } else {
                        deleteFlag = true;
                        break;
                    }
                }
                if (deleteFlag) {
                    // 若有删除饼名称，则清除对应数据
                    let nowNameList = arr.map((item: any) => item[0] || "");
                    let legendNameList = legend[0].data;
                    let deleteList = legendNameList.filter((item: string) => {
                        return !nowNameList.includes(item);
                    });
                    tempData = this.deepClone(oldData);
                    for (let i = tempData.length - 1; i >= 0; i--) {
                        if (deleteList.includes(tempData[i].name)) {
                            this.datasetLegend(legend, "delete", i, tempData[i].name);
                            tempData.splice(i, 1);
                        }
                    }
                }
            } else if (count > 0) {
                legend[0].data = [];
                for (let i = 0; i < arr.length; i++) {
                    let name = (arr[i][0] as string) || "default";
                    tempData.push({
                        value: arr[i][1] as string,
                        name: name,
                    });
                    this.datasetLegend(legend, "add", i, name);
                }
            } else {
                // 删除series
                let nowNameList = arr.map((item: any) => item[1]);
                let legendNameList = legend[0].data;
                let deleteList = legendNameList.filter((item: string) => {
                    return !nowNameList.includes(item);
                });
                tempData = this.deepClone(oldData);
                for (let i = tempData.length - 1; i >= 0; i--) {
                    if (deleteList.includes(tempData[i].name)) {
                        this.datasetLegend(legend, "delete", i, tempData[i].name);
                        tempData.splice(i, 1);
                    }
                }
            }
            Object.assign(seriesList[0], {
                data: tempData,
            });
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                    legend: legend,
                }),
                true
            );
            this.initDataSet();
            this.loadOption();
        }
        changeDatasetForScatter(arr: Array<Array<string>>) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            const legend = this.deepClone(nowOption.legend);
            let nameList = arr.shift() as Array<string>;
            let tempSeries = [];
            for (let i = 0; i < nameList.length; i += 2) {
                let name = nameList[i];
                if (name == "--") {
                    i--;
                    continue;
                }
                let obj: any = {
                    name,
                    data: [],
                };
                for (let j = 0; j < arr.length; j++) {
                    let x = arr[j][i] || "0",
                        y = arr[j][i + 1] || "0";
                    obj.data.push([parseFloat(x), parseFloat(y)]);
                }
                tempSeries.push(obj);
            }
            let count = tempSeries.length - seriesList.length;
            if (count == 0) {
                for (let i = 0; i < seriesList.length; i++) {
                    let name = tempSeries[i].name;
                    let oldName = seriesList[i].name;
                    this.datasetLegend(legend, "change", i, name, oldName);
                    seriesList[i].name = name;
                    seriesList[i].data = tempSeries[i].data;
                }
            } else if (count > 0) {
                // 新增series
                let index = -1;
                const defaultColorList = nowOption.color;
                let legendNameList = legend[0].data;
                legend[0].data = [];
                for (let i = 0; i < tempSeries.length; i++) {
                    if (!legendNameList.includes(tempSeries[i].name)) {
                        index = i;
                    }
                    this.datasetLegend(legend, "add", i, tempSeries[i].name);
                }

                if (index == 0) {
                    let temp = this.deepClone(seriesList[0]);
                    let name = tempSeries[index].name;
                    temp.name = name;
                    temp.data = tempSeries[index].data;
                    temp.singleAxisIndex && temp.singleAxisIndex--;
                    seriesList.unshift(temp);
                } else {
                    let temp = this.deepClone(seriesList[index - 1]);
                    let name = tempSeries[index].name;
                    temp.name = name;
                    temp.data = tempSeries[index].data;
                    temp = this.setSeriesColor(this.setSeriesColor, defaultColorList[index % defaultColorList.length]);
                    if (temp.select.itemStyle.borderColor) {
                        temp.select.itemStyle.borderColor = defaultColorList[index % defaultColorList.length];
                    }
                    temp.singleAxisIndex != undefined && temp.singleAxisIndex++;
                    seriesList.splice(index, 0, temp);
                }
            } else {
                // 删除series
                let nowNameList = tempSeries.map((item: any) => item.name);
                let legendNameList = legend[0].data;
                let deleteList = legendNameList.filter((item: string) => {
                    return !nowNameList.includes(item);
                });
                for (let i = seriesList.length - 1; i >= 0; i--) {
                    if (deleteList.includes(seriesList[i].name)) {
                        this.datasetLegend(legend, "delete", i, seriesList[i].name);
                        seriesList.splice(i, 1);
                    }
                }
            }
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                    legend: legend,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForCandlestick(arr: Array<Array<string>>) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            const legend = this.deepClone(nowOption.legend);
            let nameList = arr.shift() as Array<string>;
            const temp: any = {
                name: "",
                type: "candlestick",
                data: [],
            };
            if (nameList.length == 4) {
                let name = nameList[0];
                if (seriesList[0]) {
                    let oldName = seriesList[0].name;
                    this.datasetLegend(legend, "change", 0, name, oldName);
                    seriesList[0].name = name;
                    seriesList[0].data = arr;
                } else {
                    temp.name = name;
                    temp.data = arr;
                    seriesList.push(temp);
                    this.datasetLegend(legend, "add", 0, name);
                }
            } else {
                // 删除series
                this.datasetLegend(legend, "delete", 0, seriesList[0].name);
                seriesList.splice(0, 1);
            }
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                    legend: legend,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForRadar(arr: Array<Array<string>>) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            const radar = this.deepClone(nowOption.radar);
            const legend = this.deepClone(nowOption.legend);
            let valueLength = []; // 雷达图实际数据长度
            let nameList = arr.shift() as Array<string>;
            for (let item of seriesList) {
                valueLength.push(item.data.length);
            }
            let tempValueLength = this.deepClone(valueLength);
            let tempIndicatorData = [];
            for (let i = 0; i < nameList.length; ) {
                let lengthOffset = tempValueLength.shift() + 3;
                let indicatorData = [];
                for (let j = 0; j < arr.length; j++) {
                    if (arr[j][i]) {
                        indicatorData.push({
                            name: arr[j][i],
                            max: arr[j][i + 1],
                            min: arr[j][i + 2],
                        });
                    } else {
                        break;
                    }
                }
                tempIndicatorData.push(indicatorData);
                i += lengthOffset;
            }
            tempValueLength = this.deepClone(valueLength);
            let loopData = tempValueLength.shift();
            let loopCount = 0;
            let tempSeriesData: any = [];
            let seriesData = [];
            for (let i = 0; i < nameList.length; i++) {
                let obj: any = {
                    seriesName: "",
                    name: "",
                    data: [],
                };
                let temp = [];
                obj.seriesName = nameList[i - loopCount];
                obj.name = nameList[i + 3];
                for (let j = 0; j < arr.length; j++) {
                    temp.push(arr[j][i + 3]);
                }
                obj.data = temp.filter((item: any) => item != "");
                seriesData.push(obj);
                loopCount += 1;
                if (loopCount == loopData) {
                    tempSeriesData.push(seriesData);
                    seriesData = [];
                    // 循环达成指定次数，进入下一组循环
                    loopCount = 0;
                    i += 3;
                    loopData = tempValueLength.shift();
                }
            }
            console.log(tempIndicatorData, tempSeriesData);
            // 暂不支持增、删雷达
            for (let i = 0; i < radar.length; i++) {
                if (tempIndicatorData[i]) {
                    radar[i].indicator = tempIndicatorData[i];
                }
            }

            let newSeriesLength = tempSeriesData.length;
            let oldSeriesLength = seriesList.length;
            if (newSeriesLength == oldSeriesLength) {
                for (let i = 0; i < oldSeriesLength; i++) {
                    let name = tempSeriesData[i][0].seriesName;
                    this.datasetLegend(legend, "change", i, name, seriesList[i].name);
                    seriesList[i].name = name;
                    let temp = [];
                    for (let item of tempSeriesData[i]) {
                        temp.push({
                            name: item.name,
                            value: item.data,
                        });
                    }
                    seriesList[i].data = temp;
                }
            }
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                    legend: legend,
                    radar,
                }),
                true
            );
            this.initDataSet();
            this.loadOption();
        }
        changeDatasetForBoxplot(arr: Array<Array<string>>) {
            const nowOption = this.chart.getOption();
            const dataset = this.deepClone(nowOption.dataset);
            let offset = 0;
            for (let item of dataset) {
                let source = item.source;
                if (source) {
                    let count = source[0].length;
                    for (let i = 0; i < source.length; i++) {
                        source[i] = arr[i].slice(offset, offset + count);
                    }
                    offset += count;
                }
            }
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    dataset: dataset,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForHeatmap(arr: Array<Array<string>>) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            let offset = 0;
            for (let item of seriesList) {
                let source = item.data;
                let count = source[0].length;
                for (let i = 0; i < source.length; i++) {
                    source[i] = arr[i].slice(offset, offset + count);
                }
                offset += count;
            }
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForGraph(arr: Array<Array<string>>) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            if (Object.prototype.toString.call(seriesList[0].data[0]) == "[object Array]") {
                seriesList[0].data = arr;
            } else {
                seriesList[0].data = arr[0];
            }
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForSunburst(arr: Array<Array<string>>) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            let map = new Map();
            let result: any = [];
            arr.shift();
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                let parentName: any = item[2];
                if (parentName == "null") {
                    let obj = {
                        name: item[0],
                        value: parseFloat(item[1]),
                        children: [],
                    };
                    map.set(item[0], obj);
                    result.push(obj);
                } else {
                    if (map.has(parentName)) {
                        let obj = {
                            name: item[0],
                            value: parseFloat(item[1]),
                            children: [],
                        };
                        map.set(item[0], obj);
                        map.get(parentName).children.push(obj);
                    }
                }
            }
            seriesList[0].data = result;
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForParallel(arr: Array<Array<number | string>>) {
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            let offset = 0;
            for (let item of seriesList) {
                let source = item.data;
                for (let i = 0; i < source.length; i++) {
                    source[i] = arr[i + offset];
                }
                offset += item.data.length;
            }
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForSankey(arr: Array<Array<number | string>>) {
            // TOFIX: 生成桑基图的数据时，还需要设置 data.itemStyle.color
            console.log(arr);
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            const links = seriesList[0]?.links || [];
            const resetData = () => {
                // 根据links关系重新生成data内容
                let temp = new Map();
                let data = [];
                for (let item of links) {
                    let source = item.source;
                    let target = item.target;
                    if (!temp.get(source)) {
                        data.push({
                            name: source,
                        });
                        temp.set(source, 1);
                    }

                    if (!temp.get(target)) {
                        data.push({
                            name: target,
                        });
                        temp.set(target, 1);
                    }
                }
                delete seriesList[0].data;
                seriesList[0].data = data;
            };

            arr.forEach((item, i) => {
                if (links[i]) {
                    links[i].source = item[0];
                    links[i].target = item[1];
                    links[i].value = item[2];
                } else if (item[0] && item[1] && item[2]) {
                    links.push({
                        source: item[0],
                        target: item[1],
                        value: item[2],
                    });
                }
            });

            resetData();
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForFunnel(arr: Array<Array<number | string>>) {
            console.log(arr);
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            const legend = this.deepClone(nowOption.legend);
            let count = 0;
            for (let i = 0; i < seriesList.length; i++) {
                let data = seriesList[i].data;
                for (let j = 0; j < data.length; j++) {
                    let nName = arr[j + count][0] as string;
                    let oName = data[j].name;
                    if (nName != oName) {
                        this.datasetLegend(legend, "change", j, nName, oName);
                    }
                    data[j].name = nName;
                    data[j].value = arr[j + count][1];
                }
                count += seriesList[i].data.length;
            }
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                }),
                true
            );
            this.loadOption();
        }
        changeDatasetForGauge(arr: Array<Array<number | string>>) {
            console.log(arr);
            const nowOption = this.chart.getOption();
            const seriesList = this.deepClone(nowOption.series);
            let count = 0;
            for (let i = 0; i < seriesList.length; i++) {
                let data = seriesList[i].data;
                if (data) {
                    for (let j = 0; j < data.length; j++) {
                        data[j].name = arr[j + count][0] as string;
                        data[j].value = arr[j + count][1];
                    }
                    count += seriesList[i].data.length;
                }
            }
            this.initDataSet();
            this.chart.setOption(
                Object.assign(this.deepClone(nowOption), {
                    series: seriesList,
                }),
                true
            );
            this.loadOption();
        }

        showEchartEditModal(data, index) {
            this.doEditor({ option: data[0] }, data[1], data[2], "");
            this.$nextTick(() => {
                const onFinish = () => {
                    this.clickSettingList(index);
                    this.chart.off("finished", onFinish);
                };
                this.chart.on("finished", onFinish);
            });
        }

        created() {
            if (this.type == "outScreen") {
                this.showEditor = true;
            }
        }
        beforeDestroy() {
            this.$bus.$off("showEchartEditModal", this.showEchartEditModal);
        }
        mounted() {
            this.$bus.$on("showEchartEditModal", this.showEchartEditModal);
        }
    }
</script>
<i18n>
{
    "zh": {
        "echartTitle": "Apache Echarts",
        "confirmText": "插入到画布",
        "label": "标签设置",
        "series": "图例设置",
        "edit": "编辑数据",
        "line": "转化为折线图",
        "bar": "转化为柱状图",
        "stack": "转化为堆叠",
        "restore": "重置图形"
    },
    "en": {
        "echartTitle": "Apache Echarts",
        "confirmText": "Insert Into Canvas",
        "label": "Label Settings",
        "series": "Legend Settings",
        "edit": "Edit Data",
        "line": "Convert to Line Chart",
        "bar": "Convert to Histogram",
        "stack": "Convert to Stack",
        "restore": "Reset graphics"
    },
    "fr": {
        "confirmText": "Insérer dans le canevas",
        "label": "Paramètres d'étiquette",
        "series": "Paramètres de légende",
        "edit": "Modifier les données",
        "line": "Convertir en graphique linéaire",
        "bar": "Convertir en histogramme",
        "stack": "Convertir en pile",
        "restore": "Réinitialiser les graphiques"
    },
    "de": {
        "confirmText": "In Zeichenbereich einfügen",
        "label": "Beschriftungs-Einstellungen",
        "series": "Legendeneinstellungen",
        "edit": "Daten bearbeiten",
        "line": "In Liniendiagramm konvertieren",
        "bar": "In Histogramm konvertieren",
        "stack": "In Stapel konvertieren",
        "restore": "Grafiken zurücksetzen"
    },
    "jp": {
        "confirmText": "キャンバスに挿入",
        "label": "ラベルの設定",
        "series": "凡例の設定",
        "edit": "データを編集",
        "line": "折れ線グラフに変換",
        "bar": "ヒストグラムに変換",
        "stack": "積み重ねグラフに変換",
        "restore": "図をリセット"
    },
    "es": {
        "confirmText": "Insertar en Lienzo",
        "label": "Configuración de etiquetas",
        "series": "Ajustes de leyenda",
        "edit": "Editar datos",
        "line": "Convertir a gráfico de líneas",
        "bar": "Convertir a histograma",
        "stack": "Convertir a pila",
        "restore": "Restablecer gráficos"
    },
    "pt": {
        "confirmText": "Inserir na tela",
        "label": "Configurações da etiqueta",
        "series": "Configurações da legenda",
        "edit": "Editar dados",
        "line": "Converter em gráfico de linha",
        "bar": "Converter em histograma",
        "stack": "Converter em pilha",
        "restore": "Redefinir gráficos"
    },
    "it": {
        "confirmText": "Inserisci in Canvas",
        "label": "Impostazioni etichetta",
        "series": "Impostazioni legenda",
        "edit": "Modifica dati",
        "line": "Converti in grafico a linee",
        "bar": "Converti in istogramma",
        "stack": "Converti in pila",
        "restore": "Ripristina grafica"
    },
    "tw": {
        "confirmText": "插入畫布",
        "label": "標籤設定",
        "series": "圖例設定",
        "edit": "編輯資料",
        "line": "轉換為折線圖",
        "bar": "轉換為長條圖",
        "stack": "轉換為堆疊",
        "restore": "重設圖形"
    },
    "kr": {
        "confirmText": "캔버스에 삽입",
        "label": "라벨 설정",
        "series": "범례 설정",
        "edit": "데이터 편집",
        "line": "선형 차트로 변환",
        "bar": "히스토그램으로 변환",
        "stack": "스택으로 변환",
        "restore": "그래픽 재설정"
    }
}
</i18n>
